import { render, staticRenderFns } from "./OrkToggle.vue?vue&type=template&id=2f75c8bf&scoped=true&"
import script from "./OrkToggle.vue?vue&type=script&lang=js&"
export * from "./OrkToggle.vue?vue&type=script&lang=js&"
import style0 from "./OrkToggle.vue?vue&type=style&index=0&id=2f75c8bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75c8bf",
  null
  
)

export default component.exports